import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives } from "vue";
import _imports_0 from '@/assets/images/icons/open.svg';
import _imports_1 from '@/assets/images/filecoin-logo.svg';
import _imports_2 from '@/assets/images/icons/link.svg';
const _hoisted_1 = {
  class: "row mb-2"
};
const _hoisted_2 = {
  class: "col-12 text-left fw-extra-bold fsi-16"
};
const _hoisted_3 = {
  class: "row mt-3"
};
const _hoisted_4 = {
  class: "col-12 text-left fw-medium fsi-16 d-flex align-items-center justify-content-between"
};
const _hoisted_5 = {
  style: {
    "min-width": "180px"
  }
};
const _hoisted_6 = {
  class: "text-right fw-medium fsi-14"
};
const _hoisted_7 = {
  class: "fw-bold ml-2"
};
const _hoisted_8 = {
  class: "col-12 text-left fw-medium fsi-16 d-flex align-items-center justify-content-between mt-3"
};
const _hoisted_9 = {
  style: {
    "min-width": "180px"
  },
  class: "d-flex align-items-center"
};
const _hoisted_10 = {
  class: "mr-1"
};
const _hoisted_11 = {
  class: "text-right fw-medium fsi-14"
};
const _hoisted_12 = {
  class: "fw-bold ml-2"
};
const _hoisted_13 = {
  class: "col-12 text-left fw-medium fsi-16 d-flex align-items-center justify-content-between mt-3"
};
const _hoisted_14 = {
  style: {
    "min-width": "180px"
  },
  class: "d-flex align-items-center"
};
const _hoisted_15 = {
  class: "mr-1"
};
const _hoisted_16 = {
  class: "text-right fw-medium fsi-14"
};
const _hoisted_17 = /*#__PURE__*/_createElementVNode("img", {
  style: {
    "width": "16px",
    "margin-bottom": "1px",
    "color": "white",
    "cursor": "pointer"
  },
  src: _imports_0,
  alt: ""
}, null, -1);
const _hoisted_18 = {
  key: 0,
  class: "col-12"
};
const _hoisted_19 = {
  class: "mt-3"
};
const _hoisted_20 = {
  class: "row mb-4"
};
const _hoisted_21 = {
  class: "col-12 mt-3"
};
const _hoisted_22 = {
  class: "fw-bold"
};
const _hoisted_23 = {
  class: "mt-1 col-12 mt-2"
};
const _hoisted_24 = {
  style: {
    "background-color": "#fafafa",
    "border-radius": "5px"
  },
  class: "pl-2 pr-2"
};
const _hoisted_25 = {
  class: "form-group mb-4"
};
const _hoisted_26 = {
  class: "position-relative"
};
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", {
  class: "position-absolute d-flex justify-content-center align-items-center h-100",
  style: {
    "left": "0",
    "z-index": "100",
    "width": "4rem"
  }
}, [/*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "1.8rem"
  }
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  style: {
    "width": "29px",
    "height": "29px"
  },
  alt: ""
})])], -1);
const _hoisted_28 = {
  class: "position-absolute d-flex justify-content-center align-items-center h-100",
  style: {
    "right": "0",
    "width": "6rem"
  }
};
const _hoisted_29 = ["disabled"];
const _hoisted_30 = {
  class: "row mb-3 mt-2"
};
const _hoisted_31 = {
  class: "col-12 text-left fw-extra-bold fsi-16 mt-2",
  style: {
    "cursor": "pointer"
  }
};
const _hoisted_32 = {
  class: "row"
};
const _hoisted_33 = {
  class: "col-6 text-left fw-medium fsi-14"
};
const _hoisted_34 = {
  class: "col-6 text-right fw-medium fsi-14 opacity-08"
};
const _hoisted_35 = {
  class: "row mt-3"
};
const _hoisted_36 = {
  class: "col-6 text-left fw-medium fsi-14"
};
const _hoisted_37 = {
  class: "col-6 text-right fw-medium fsi-14 opacity-08"
};
const _hoisted_38 = {
  class: "mt-4"
};
const _hoisted_39 = {
  key: 1,
  class: "d-flex align-items-center"
};
const _hoisted_40 = {
  key: 0,
  class: "ml-2 cursor-pointer icon-hover"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_skeleton_item = _resolveComponent("el-skeleton-item");
  const _component_i_skeleton = _resolveComponent("i-skeleton");
  const _component_Tooltip = _resolveComponent("Tooltip");
  const _component_Tip = _resolveComponent("Tip");
  const _component_el_slider = _resolveComponent("el-slider");
  const _component_IndicatorValue = _resolveComponent("IndicatorValue");
  const _component_el_button = _resolveComponent("el-button");
  return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('farm.console.Howmachmorewouldyouliketowithdrow')), 1)]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('farm.console.Maximumwithdrawal')), 1), _createVNode(_component_i_skeleton, {
    loading: _ctx.currentLoading
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_6, [_createVNode(_component_el_skeleton_item, {
      variant: "p",
      style: {
        "width": "50%"
      }
    })])]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_7, _toDisplayString($options.externalFormatFilPrice(_ctx.maximumWithdrawal)), 1)]),
    _: 1
  }, 8, ["loading"])]), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('farm.console.SafetyBuffer')), 1), _createVNode(_component_Tooltip, null, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('subpool.SafetyBufferTip')), 1)]),
    _: 1
  })]), _createVNode(_component_i_skeleton, {
    loading: _ctx.currentLoading
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_11, [_createVNode(_component_el_skeleton_item, {
      variant: "p",
      style: {
        "width": "50%"
      }
    })])]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_12, _toDisplayString($options.externalFormatFilPrice(_ctx.safetyBuffer)), 1)]),
    _: 1
  }, 8, ["loading"])]), _createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$t('farm.console.Payee')), 1), _createVNode(_component_Tooltip, null, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('farm.console.PayeeTip')), 1)]),
    _: 1
  })]), _createVNode(_component_i_skeleton, {
    loading: _ctx.currentLoading
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_16, [_createVNode(_component_el_skeleton_item, {
      variant: "p",
      style: {
        "width": "50%"
      }
    })])]),
    default: _withCtx(() => [_createElementVNode("div", {
      class: "fw-bold ml-2 link-text-ordinary",
      onClick: _cache[0] || (_cache[0] = $event => $options.gotoAddress(_ctx.oldOwnerShow, _ctx.$i18n.locale))
    }, [_createTextVNode(_toDisplayString(_ctx.oldOwnerShow) + " ", 1), _hoisted_17])]),
    _: 1
  }, 8, ["loading"])]), _ctx.isExceedMaxDebtRate && !_ctx.currentLoading ? (_openBlock(), _createElementBlock("div", _hoisted_18, [_createElementVNode("div", _hoisted_19, [_createVNode(_component_Tip, {
    level: "warring"
  }, {
    btnGroup: _withCtx(() => [_createElementVNode("a", {
      class: "mr-4 cursor-pointer",
      style: {
        "text-decoration": "underline"
      },
      onClick: _cache[1] || (_cache[1] = (...args) => $options.goToRepay && $options.goToRepay(...args))
    }, _toDisplayString(_ctx.$t('farm.console.Gotorepay')), 1)]),
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('subpool.Yourcurrentdebtratiorateexceedsthemaximumdebtratio').replace('$$$', `${$options.formatUnits(_ctx.poolDebtRatio, 2)}%`).replace('$2$$', `${$options.formatUnits(_ctx.poolMaxDebtRatio, 2)}%`)) + " ", 1)]),
    _: 1
  })])])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_20, [_createElementVNode("div", _hoisted_21, [_createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.$t('farm.console.Amount')), 1)]), _createElementVNode("div", _hoisted_23, [_createElementVNode("div", _hoisted_24, [_createVNode(_component_el_slider, {
    disabled: _ctx.currentLoading,
    modelValue: $data.sliderValue,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.sliderValue = $event),
    "format-tooltip": $options.sliderFormatTip,
    marks: _ctx.marks
  }, null, 8, ["disabled", "modelValue", "format-tooltip", "marks"])])])]), _createElementVNode("div", _hoisted_25, [_createElementVNode("div", _hoisted_26, [_hoisted_27, _createElementVNode("div", _hoisted_28, [_createElementVNode("button", {
    type: "button",
    class: "btn btn-info btn-sm btn-max",
    style: {
      "padding": "4px 15px"
    },
    onClick: _cache[3] || (_cache[3] = (...args) => $options.max && $options.max(...args))
  }, _toDisplayString(_ctx.$t("max")), 1)]), _withDirectives(_createElementVNode("input", {
    class: "form-control shadow-none stake-input",
    disabled: _ctx.currentLoading,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => $data.amount = $event),
    onFocus: _cache[5] || (_cache[5] = (...args) => $options.amountValueFocus && $options.amountValueFocus(...args)),
    onBlur: _cache[6] || (_cache[6] = (...args) => $options.amountValueBlur && $options.amountValueBlur(...args)),
    onInput: _cache[7] || (_cache[7] = (...args) => $options.amountValueChange && $options.amountValueChange(...args)),
    type: "number",
    placeholder: "0.00",
    autocomplete: "off",
    id: "fname2",
    required: ""
  }, null, 40, _hoisted_29), [[_vModelText, $data.amount]])])]), _createElementVNode("div", _hoisted_30, [_createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.$t('farm.console.Isthiswhatyouexpected')), 1)]), _createElementVNode("div", null, [_createElementVNode("div", _hoisted_32, [_createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.$t('farm.console.AvailableBalance')), 1), _createElementVNode("div", _hoisted_34, [_createVNode(_component_IndicatorValue, {
    "old-value": _ctx.availableBalance,
    "new-value": _ctx.expectedAvailableBalance
  }, null, 8, ["old-value", "new-value"])])]), _createElementVNode("div", _hoisted_35, [_createElementVNode("div", _hoisted_36, _toDisplayString(_ctx.$t('farm.console.MaximumBorrowingLimit')), 1), _createElementVNode("div", _hoisted_37, [_createVNode(_component_IndicatorValue, {
    "old-value": _ctx.availableBorrowingAmount,
    "new-value": _ctx.afterAvailableBorrowingAmount
  }, null, 8, ["old-value", "new-value"])])])]), _createElementVNode("div", _hoisted_38, [!_ctx.isConnected ? (_openBlock(), _createElementBlock("button", {
    key: 0,
    class: "btn btn-primary w-100 border-radius-20",
    type: "submit",
    onClick: _cache[8] || (_cache[8] = (...args) => $options.connectWallet && $options.connectWallet(...args))
  }, _toDisplayString(_ctx.$t('connect-wallet')) + " " + _toDisplayString(_ctx.isConnecting ? ' (connecting...)' : ''), 1)) : _createCommentVNode("", true), _ctx.isConnected ? (_openBlock(), _createElementBlock("div", _hoisted_39, [_createVNode(_component_el_button, {
    loading: _ctx.currentLoading || $data.loading || _ctx.assetsLoading,
    disabled: parseFloat($data.amount) <= 0 || $data.amount === '',
    class: "btn btn-primary w-100 i-button",
    onClick: $options.withdraw
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString($data.btnText !== '' ? $data.btnText : _ctx.$t('farm.console.WITHDRAW')), 1)]),
    _: 1
  }, 8, ["loading", "disabled", "onClick"]), $data.hash !== '' ? (_openBlock(), _createElementBlock("div", _hoisted_40, [_createElementVNode("img", {
    onClick: _cache[9] || (_cache[9] = $event => $options.gotoHash($data.hash, _ctx.$i18n.locale)),
    style: {
      "width": "32px"
    },
    src: _imports_2,
    alt: ""
  })])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)])]);
}